module.exports = __webpack_public_path__ + "static/media/book-spells.49ed542b.svg";